import { DialogActions, SxProps, Theme } from '@mui/material';
import React from 'react';

import Button from '~/components/Commons/Button';
import LoadingProgress from '../LoadingProgress';

function DialogButtons({
  isSubmitting,
  handleDialogConfirm,
  acceptText = 'Save',
  acceptDisabled = false,
  acceptSx,
  showCloseButton,
  handleDialogClose,
  cancelText,
}: {
  isSubmitting?: boolean;
  handleDialogConfirm?: ((e: React.MouseEvent<HTMLElement>) => void) | null | undefined;
  acceptText?: string;
  acceptDisabled?: boolean;
  acceptSx?: SxProps<Theme>;
  showCloseButton?: boolean;
  handleDialogClose?: (e: React.MouseEvent<HTMLElement>) => void;
  cancelText?: string;
}) {
  return (
    <DialogActions sx={{ justifyContent: 'center', marginBottom: '10px' }}>
      {isSubmitting ? (
        <LoadingProgress loading={isSubmitting} />
      ) : (
        <>
          {handleDialogConfirm && (
            <Button
              onClick={handleDialogConfirm}
              color={acceptSx ? undefined : 'primary'}
              name={acceptText}
              disabled={acceptDisabled}
              sx={acceptSx}
            >
              {acceptText}
            </Button>
          )}
          {showCloseButton && (
            <Button
              onClick={handleDialogClose}
              color="primary"
              name={handleDialogConfirm ? 'Cancel' : 'Close'}
            >
              {cancelText || (handleDialogConfirm ? 'Cancel' : 'Close')}
            </Button>
          )}
        </>
      )}
    </DialogActions>
  );
}

export default DialogButtons;
